export default __webpack_public_path__ + "static/media/ExpertCRM.00d31de9.png";